import React from 'react'
import {Img} from "react-image";
import AdminListView from "./components/AdminListView";
import LoadingSpinner from "../../components/LoadingSpinner";
import {Link} from "react-router-dom";
import TalentTeam from "../../models/TalentTeam";
import User from "../../models/User";
import UserImageCircle from "../../components/UserImageCircle";

export default class TalentManagerTeamsList extends AdminListView
{
    static path = '/manager/teams';

    static modelClass() {
        return User
        // return TalentTeam
    };
    static FailedEventName = 'TalentTeam@FetchForTalentManagerFailed';
    static SuccessEventName = 'TalentTeam@FetchForTalentManagerUpdated';
    static modelName = 'Talent Team';
    static searchPlaceholder = 'Search by name, or project interests'
    static tableClass = "talent-manager-team-table"

    static statusOptions() {
        return TB.map(laravel.team_statuses, status => ({label: status, value: status}))
    }

    static events()
    {
        let pageEvents = super.events();


        return {
            ...pageEvents,
        }
    }

    static FetchAllRequest() {
        return TalentTeam.FetchAllRequest;
    }

    async fetchResultsForParams(params, refresh) {
        return TalentTeam.fetchAllTeamsForTalent(params, {});
    };

    constructor(props) {
        super(props);

        this.state = {
            ...this.state
        }
    }


    listDetails(team)
    {
        const members = TB.filter(team.positions || [], pos => pos.has_joined)
        return (
            <tr key={`team-${team.id}`}>
                <td>
                    <div className="flex flex-col-reverse items-center gap-1 5">
                        <div className="w-[155px] justify-center items-center flex flex-col">
                            <Img loader={<LoadingSpinner/>} className={TB.mapClass("img-fluid max-w-full", {
                                'img-grayscale': !team.banner_image_path
                            })}
                                 src={[team.banner_image_path || '/images/heads.png']}/>
                        </div>
                        <p className="text-lg font-semibold">
                            {team.name}
                        </p>
                    </div>
                </td>
                <td>
                    <div className="flex flex-col gap-1 items-start">
                        {TB.take(members, 4).map(position => (
                            <div key={`member-team${team.id}-${position.id}`} className="flex flex-row gap-2">
                                <UserImageCircle user={position.user} hideTooltip={true} size={32}/>

                                <p>{position.user.fullName()}</p>
                            </div>
                        ))}
                        {members?.length > 4 && (
                            <p className="text-info italic">+ {members?.length - 4} more...</p>
                        )}
                    </div>
                </td>

                <td>
                    {team.talent_service_groups?.length > 0 ? (
                        <ul className="list-disc ml-3">
                            {team.talent_service_groups.map(group => (
                                <li key={`group-${group.id}-team-${team.id}`}>{group.name}</li>
                            ))}
                        </ul>
                    ) : "None"}

                </td>
                <td>
                    {team.is_approved ? (!team.is_available ? (
                        <p><i className="fas fa-times-circle text-danger mr-2" /> Approved/Inactive</p>
                    ) : (
                        <p><i className="fas fa-check-circle text-success mr-2" /> Approved/Active</p>
                    )) : (
                        <p><i className="fas fa-spinner mr-2" /> Pending Setup</p>
                    )}
                </td>

                <td>
                    <Link to={`/talent/manager/team/manage/${team?.id}`} className="btn btn-primary">
                        Manage
                    </Link>
                </td>

            </tr>
        )
    }

    listHeaders()
    {

        return [
            "Name",
            "Members",
            "Talent Service Groups",
            "Status",
            "Actions"
        ]
    }
    renderActionButton() {
        return (
            <Link to={`/talent/manager/team/setup`} className="btn btn-primary">
                Add New Team
            </Link>
        );
    }

    renderListFooter() {
        return (
            <div>

            </div>
        )
    }
}